import { styled } from '@styledComponents';
import { themeSpace } from '@utils/styledTheme.util';

export const StyledOL = styled.ol`
  & > li {
    counter-increment: item;
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 1.75rem;
    text-indent: -2rem;
    &::before {
      content: counter(item) '.';
      display: inline-block;
      font-weight: bold;
      padding-right: 1.5rem;
      text-align: right;
      width: 1.95rem;
    }
    margin-top: ${themeSpace(5)};
  }
  .no-padding {
    margin-top: ${themeSpace(8)};
  }
  .no-padding > li {
    padding: 0;
    text-indent: 0;
  }
  & p {
    padding: 0;
    text-indent: 0;
  }
`;
